let apiConfig = null;
/**
 * Configure the Velavu API client
 */
export function configure(config) {
    apiConfig = config;
}
/**
 * Get the current API configuration
 */
export function getConfig() {
    if (apiConfig === null) {
        throw new Error("Velavu API has not been configured. Call configure() first.");
    }
    return apiConfig;
}
//# sourceMappingURL=config.js.map